import { DATASET } from '@src/utils/constants';
import { useMemo } from 'react';
import { arddDimension, arddMetric } from '../constants';
import moment from 'moment';
import { getDistributionData } from '@src/api/metricContainer';
import { get } from 'lodash';
import { formatQueryStatus } from './utils';
import useQueryParams from '@src/components/widget-panel/hooks/useQueryParams';
import useWidgetQuery from '@src/components/widget-panel/hooks/useWidgetQuery';
import { useSelector } from 'react-redux';

export function useDurationDistribution({ wid, enabled = true }) {
  const { interval, filter: globalFilter, _rKey, liveMode } = useQueryParams();

  // build query
  const query = useMemo(() => {
    const filter = [...globalFilter];
    const q = {
      dataset: DATASET,
      filter,
      metrics: [arddMetric],
      dimension: arddDimension,
      interval: `${moment(interval.from).toISOString()}/${moment(interval.to).toISOString()}`,
      isLiveMode: false,
      queryGranularity: 'ALL',
      options: {
        withTotals: true,
      },
    } as any;
    return q;
  }, [globalFilter, interval]);

  const { data, ...queryStatus } = useWidgetQuery({
    wid,
    queryKey: ['widget', 'network-distribution', query],
    queryFn: () => {
      return getDistributionData(query).then((response) => {
        const rawData = get(response, ['data', 'data', '0', 'result'], []);
        const total = get(response, ['data', 'totals', '0', 'result', arddMetric], {});
        const rows = rawData.map((r) => ({
          name: r[arddDimension],
          value: r[arddMetric],
        }));
        return { rows, total };
      });
    },
    options: {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: enabled && !liveMode,
      staleTime: 5 * 60 * 1000, // 5m
    },
  });

  return {
    ...formatQueryStatus({ ...queryStatus, isEmpty: !data?.rows?.length }),
    data: data?.rows,
    total: data?.total,
  };
}
